import { useMemo } from "react";
import { useObservable } from "../../hooks";
import SymbolDataProvider from "./../SymbolDataProvider";
export var useSymbolData = function useSymbolData() {
  return useObservable(function () {
    return SymbolDataProvider.getSymbolDataObservable();
  }, SymbolDataProvider.getSymbolData());
};
export function useSymbol(base, quote) {
  var symbolData = useSymbolData();
  return useMemo(function () {
    if (!base) {
      return undefined;
    }
    if (quote) {
      return symbolData.symbolMap.get("".concat(base, "/").concat(quote));
    }
    return symbolData.symbolMap.get(base);
  }, [symbolData, base, quote]);
}
export var useSymbols = function useSymbols(pairs) {
  var symbolData = useSymbolData();
  return useMemo(function () {
    if (!(pairs !== null && pairs !== void 0 && pairs.length)) {
      return undefined;
    }
    return pairs.reduce(function (sum, _ref) {
      var base = _ref.base,
        quote = _ref.quote;
      sum["".concat(base, "/").concat(quote)] = symbolData.symbolMap.get("".concat(base, "/").concat(quote));
      return sum;
    }, {});
  }, [pairs, symbolData]);
};